module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_02_Trail-01-9cb3a18702bebeb5e63c8f261b836a55.png";